import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export default function SlotConflictDialog() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const h = (e) => setInfo(e.detail);
    window.addEventListener('slot-conflict', h);
    return () => window.removeEventListener('slot-conflict', h);
  }, []);
  if (!info) return null;
  const close = (ok) => { const i = info; setInfo(null); ok ? i.onConfirm() : i.onCancel(); };
  return (
    <Dialog open onOpenChange={() => close(false)}>
      <DialogContent className="rounded-3xl border-brand-border" data-testid="slot-conflict-dialog">
        <DialogHeader><DialogTitle className="font-heading text-brand-text">Horário ocupado</DialogTitle></DialogHeader>
        <p className="text-sm text-brand-text" data-testid="slot-conflict-message">{info.message}</p>
        <div className="flex gap-2">
          <button onClick={() => close(false)} className="flex-1 border border-brand-border text-brand-muted rounded-full py-2.5 text-sm" data-testid="slot-conflict-cancel">Cancelar</button>
          <button onClick={() => close(true)} className="flex-1 bg-brand-green text-white rounded-full py-2.5 text-sm font-medium" data-testid="slot-conflict-confirm">Marcar na mesma</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
